// src/cmps/UserProfile/UserWatchlist/WatchlistFilterMobile.jsx
import { Link } from 'react-router-dom'
import { getAnimeDetailsUrl } from '../../../services/util.service'
import { SearchIconInput, RandomIconInput } from '../../ui/icons/user'

export function WatchlistFilterMobile({
  filterText,
  setFilterText,
  filterStatus,
  setFilterStatus,
  watchlist = [],
  statuses = [],
}) {
  const randomAnime = watchlist.length
    ? watchlist[Math.floor(Math.random() * watchlist.length)]
    : null

  return (
    <section
      className="md:hidden mb-6 border-b border-white/15"
      aria-label="סינון אנימות במובייל"
    >
      {/* search + controls */}
      <div className="mb-4 flex gap-2">
        {/* search */}
        <div className="flex items-center gap-2 flex-grow px-3 py-2">
          <SearchIconInput aria-hidden="true" />
          <label htmlFor="mobile-watch-filter" className="sr-only">
            חיפוש ברשימה
          </label>
          <input
            id="mobile-watch-filter"
            type="search"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            placeholder="חיפוש ברשימה"
            aria-label="חיפוש אנימה ברשימה"
            className="flex-grow text-sm bg-transparent text-white placeholder:text-softText outline-none"
          />
        </div>

        {/* status select + random */}
        <div className="flex items-center gap-4">
          {/* select */}
          <label htmlFor="statusSelect" className="sr-only">
            בחירת סטטוס
          </label>
          <select
            id="statusSelect"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            aria-label="בחירת סטטוס ברשימה"
            className="bg-background text-sm text-primary"
          >
            <option value="">הכל</option>
            {statuses.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>

          {/* random */}
          {randomAnime && (
            <Link
              to={getAnimeDetailsUrl(randomAnime)}
              title="אנימה אקראית"
              aria-label="מעבר לאנימה אקראית"
              className="flex items-center justify-center bg-accent rounded-full p-2 hover:bg-primary transition"
            >
              <RandomIconInput aria-hidden="true" />
            </Link>
          )}
        </div>
      </div>
    </section>
  )
}
